module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    attrs: {
      "id": "app"
    }
  }, [_h('player-summaries', {
    attrs: {
      "playersData": _vm.playersData
    }
  }), " ", " ", _h('owned-games', {
    attrs: {
      "gamesData": _vm.gamesData,
      "api": _vm.api
    },
    on: {
      "selectGame": _vm.changeAppId
    }
  }), " ", (_vm.gameDataLoaded) ? _h('achievements', {
    attrs: {
      "achievementsData": _vm.achievementsData,
      "gameSchema": _vm.gameSchema,
      "api": _vm.api
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/schulz/AppData/Roaming/npm/~/vbuild/~/vue-loader/lib/template-compiler.js?id=data-v-4611ef0c!C:/Users/schulz/AppData/Roaming/npm/~/vbuild/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 170
// module chunks = 0